import { useState, useEffect, useContext } from 'react';
import { dataStore } from 'store/data';
import { appStore } from 'store/app';

const useDiscountedPrice = () => {
  const [dataState] = useContext(dataStore);
  const [appState] = useContext(appStore);
  const [discountedPrice, setTotalPrice] = useState(0);

  const sizeId = appState.customData.bottle.size;

  useEffect(() => {
    const otherPrices = appState.customData.partsList.map((item) => {
      if (item.wc_discount_rate > 0) {
        return Number(item.wc_discounted_price.replace(/,/, ''));
      } else {
        return item.price ? Number(item.price) : 0;
      }
    });
     // 底ラバーがある場合、底ラバーの価格を追加
    let bootPrice = 0
    if (appState.customData.bootsList) {
      if(appState.customData.bootsList[0].variants[sizeId].wc_discount_rate > 0)  {
        bootPrice = Number(appState.customData.bootsList[0].variants[sizeId].wc_discounted_price.replace(/,/, ''));
      } else {
        bootPrice = Number(appState.customData.bootsList[0].variants[sizeId].price);
      }
    }
    // ボトル以外のパーツの合計値
    const totalOptions = otherPrices.reduce((sum, element) => sum + element, 0);
    // ボトルを足して合計金額を算出
    const discountedPrice = Number(appState.customData.bottle.wc_discounted_price.replace(/,/, '')) + totalOptions + bootPrice;
    setTotalPrice(discountedPrice);
  }, [appState.customData, dataState]);

  return [discountedPrice];
};

export default useDiscountedPrice;
